import { render } from "./Addtextcampaign.vue?vue&type=template&id=0bf3262f"
import script from "./Addtextcampaign.vue?vue&type=script&lang=js"
export * from "./Addtextcampaign.vue?vue&type=script&lang=js"

import "./Addtextcampaign.vue?vue&type=style&index=0&id=0bf3262f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__